import ApiService from './ApiService'

export type ShredResponse = {
  shredId: string
  summary: string
  plan: string
  htmlPlan: string
  progress: number
  name: string
  startDate: string
  coinsUsed: string
  status: 'CREATED' | 'GENERATING_SPECS' | 'SPECS_GENERATED' | 'PROMPT_VALIDATED' | 'PLAN_GENERATED' | 'IN_GENERATION' | 'RESUMING_GENERATION' | 'DONE' | 'FAILED' | 'STOPPING' | 'STOPPED'
  isFailed: boolean
  generationState: 'ACTIVE' | 'DONE' | 'FAILED' | 'STOPPING' | 'STOPPED'
  estimateTime: number
  model: boolean
  failed: boolean
  generationTime: string
  modelValidated: boolean
  step: string
  repoUploaded: boolean
  failedToPush: boolean
}

export type ServiceStatusResponse = {
  status: 'IDLE' | 'GENERATING_SHREDS' | 'FAILED'
  shreds: ShredResponse[]
  microServiceName: string
}

export type SingleShredGenerationResponse = {
  status: number
  state: string
  body: string
}

export async function apiGetShredsList<T>(
  serviceId: string,
) {
  return ApiService.fetchData<T>({
    url: `/api/services/${serviceId}/shreds`,
    method: 'get',
  })
}

export async function apiGenerateShreds<T>(
  serviceId: string,
  shredModel: boolean
) {
  return ApiService.fetchData<T>({
    url: `api/services/${serviceId}/generate_shreds/${shredModel}`,
    method: 'post'
  })
}

export async function apiGenerateSingleShred<T>(
  serviceId: string,
  shredId: string
) {
  return ApiService.fetchData<T>({
    url: `api/services/${serviceId}/generate_single_shred/${shredId}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {}
  })
}

export async function apiCreateSimpleProjectList<T, U extends Record<string, unknown>>(
  serviceId: string,
  data: U
) {
  return ApiService.fetchData<T>({
    url: `/api/services/${serviceId}/shreds`,
    method: 'post',
    data: {...data, projectType: 'SINGLE_SERVICE',},
  })
}